<!--服务流程-->
<template>
  <div class="service-process-list" ref="showCounttext">
    <div class="content-wrap-box" align="center">
      <img style="max-width: 100%" :src="ossPath + '/pages/home/service-content-info.png'" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "serviceProcess",
  data(){
    const ossPath = this.ossPath;
    const icon = {
      img1: ossPath + "/pages/home/service_process-01.png",
      img2: ossPath + "/pages/home/service_process-02.png",
      img3: ossPath + "/pages/home/service_process-03.png",
      img4: ossPath + "/pages/home/service_process-04.png",
      img5: ossPath + "/pages/home/service_process-05.png",
    };
    return {
      show:false,
      images:{
        arrowRight: ossPath + "/pages/home/arrow-right.png",
      },
      list:[
        {image:icon.img1, label:"团长发起开团", text:"货代查看平台优质舱位,选择各分段供应商后,团长支持自定义价格，填写自带货物信息后,发起开团.",},
        {image:icon.img2, label:"分享拼团链接", text:"团长在pc和小程序分享拼团链接,邀请更多货代参与跟单.",},
        {image:icon.img3, label:"货代参与拼团", text:"货代根据团长分享的跟单链接,填写货物信息后,跟单成功.",},
        {image:icon.img4, label:"团满", text:"在截仓日之前,该拼团的集装箱拼满后(例如40HQ柜子拼满70CBM),该拼团成功",},
        // {image:icon.img5, label:"团长返佣金", text:"货物入仓,平台完成货物运输后,根据实际装载运输重量,给团长返还佣金到个人账户.",},
      ],
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    this.$nextTick(()=>{
      this.handleScroll();
    })
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let scroll = window.pageYOffset;
      let windowHeight = window.innerHeight;
      let elementTop = this.$refs.showCounttext.offsetTop;
      if (scroll + windowHeight >= elementTop) {
        this.show = true;
        window.removeEventListener("scroll", this.handleScroll);
      }
    },

  },
}
</script>

<style scoped lang="less">
.service-process {
  &-list{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &__item{
    width: 200px;
    height: 220px;
    background: transparent;
    border: 1px solid #D6D6D6;
    border-radius: 20px;
    padding: 10px 9px 0;
    text-align: center;
    box-sizing: border-box;
    .image{
      display: block;
      width: 78px;
      height: 78px;
      margin: 0 auto 9px;
      animation-delay: 0.3s
    }
    .label{
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      //line-height: 36px;
      line-height: 1;
      margin-bottom: 10px;
    }
    .text{
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 24px;
    }
  }
  &__newitem {
    position: relative;
    width: 252px;
    height: 256px;
    border-radius: 20px;
    // padding: 10px 9px 0;
    text-align: center;
    box-sizing: border-box;
    background: url(https://huodaipin-test.oss-cn-hongkong.aliyuncs.com/web/v1.0.0/pages/home/service-process-bg.png) no-repeat;
    z-index: 1;
    cursor: context-menu;
    &::before {
      content: "";
      display: block;
      position: absolute;
      top: 26px;
      left: 23px;
      width: 198px;
      height: 198px;
      background: rgb(183, 56, 70);
      border: 2px solid #FFFFFF;
      box-shadow: 0px 0px 27px 0px rgba(0,0,0,0.04);
      border-radius: 10px;
      opacity: 0;
      transition: all .3s;
      
    }
    &:hover {
      &::before {
        opacity: 0.8;
      }
      .image{
        display: none;
      }
      .containt-box{
        position: relative;
        display: block;
        color: #FFFFFF;
        z-index: 1;
      }
      .idx {
        color: #FFFFFF;
        z-index: 1;
        &::before {
          top: -2px;
          left: -27px;
          position: absolute;
          content: "";
          display: block;
          border: 35px solid transparent;
          border-top-color: rgba(183, 56, 71, 0.5);
          filter: blur(2px);
        }
        span {
          position: absolute;
        }
      }
      .label {
        display: none;
      }
    }
    .image{
      display: block;
      margin: 90px auto 9px;
      height: 35px;
      animation-delay: 0.3s
    }
    .idx {
      position: absolute;
      top: 30px;
      left: 50%;
      margin-left: -8px;
      font-size: 24px;
      font-weight: bold;
      color: #B73846;
    }
    .label {
      margin: 0 auto;
      // text-align: center;
      max-width: 72px;
      margin-top: 20px;
      color: #333333;
      font-size: 17px;
      font-weight: 600;
    }
    .containt-box {
      display: none;
      width: 128px;
      margin: 80px auto 0;
      text-align: left;
      letter-spacing: 1px;
    }
  }
}
.none {
  display: none;
}

/* 箭头 */
.door-box-next{
  flex: 1;
  height: 120px;
  position: relative;
  z-index: 1;
  .arrows-right{
    position: absolute;
    z-index: 1;
    left: 50%;
    top: 50%;
    display: block;
    margin-left: -12px;
    margin-top: -9px;
    width: 25px;
    height: 18px;
  }
}

</style>

<style lang="scss" scoped>
  .content-wrap-box {
    width: 100%;
    .process-bar {
      position: relative;
      width: 100%;
      height: 73px;
      img {
        position: absolute;
        width: 100%;
      }
    }
    .bar-title {
      display: flex;
      position: relative;
      justify-content: space-between;
      .title-item {
        width: 25%;
        text-align: center;
        line-height: 73px;
        font-size: 28px;
        color: #FFFFFF;
        letter-spacing: 1px;
      }
    }
    .process-item-info {
      padding: 15px;
      display: flex;
      position: relative;
      justify-content: space-between;
      .process__item {
        width: 25%;
        color: #FFFFFF;
        font-size: 16px;
        line-height: 27px;
        &-box {
          padding: 25px;
          p {
            padding: 20px 26px;
            padding-top: 40px; 
            width: 188px;
            height: 170px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/serviceProcess.vue